/**
 * client/src/lib/breathing-pulse.ts
 * The one loading motion (CLAUDE.md §Design Constraints): a neutral breathing
 * pulse, `scale: [1, 1.04, 1]` over 2.4s, looping. Shared by the labelled
 * `LoadingState` and the auth-entry ceremony cards so the spec has one owner.
 */

export const PULSE_ANIMATE = { scale: [1, 1.04, 1] as number[] } as const;

export const PULSE_TRANSITION = {
  duration: 2.4,
  repeat: Infinity,
  repeatType: "loop" as const,
  ease: "easeInOut",
} as const;
